import React from "react";
import Switch from "@mui/material/Switch";
//import makeStyles from '@mui/style/makeStyles';
//import Switch from "@mui/material/Switch";
import { styled } from "@mui/system";
  
export default function MUISwitchFunnel({checkedA,setStateVarConsumerSaver,energyconsumersaver,widgetprop}) {
    //console.log("IN MUISwitchFunnel I AM IN");

    //{console.log("props.widgetprop.props.extended.switch_properties.backgroundcolor,",widgetprop.props.extended.switch_properties.switchthumb.color)}
    const MaterialUISwitch = styled(Switch)(({ theme }) => ({
      width: widgetprop.props.extended.switch_properties.width,
      height: "28px",
      padding: "0px",
      justifyContent:"center",
      '& .MuiSwitch-switchBase': {
            color: "#B5BFBC",
            padding: "0px",
            justifyContent:"center",
            '&.Mui-checked + .MuiSwitch-track': {
                backgroundColor: "#005C8E",      
            },
       },
      '& .MuiSwitch-thumb': {
            color: "#E0E0E0",
            width: "20px",
            height: "20px",
            margin: "4px 5px 4px 5px",
            padding:"0px"
      },
      '& .MuiSwitch-track': {
            borderRadius: "20px",
            backgroundColor:"#005C8E",
            justifyContent:"center",
            opacity: "1 !important",
            '&:after': {
              color: "#E0E0E0",
              fontSize: "11px",
              position: "relative",
              marginLeft:"45px",
              marginTop:"10px",
              paddingTop:"10px",
              content:(energyconsumersaver==false)?'"Savers"':'""'
          },
    
      },
      '& .Mui-checked': {
          color: "#005C8E",
          transform: "translateX(10px) !important",
          transitionDuration: '4s',
          transitionDelay:'10s',
          '&: before': {
            color: "#E0E0E0",
            fontSize: "11px",
            position: "relative",
            marginBottom:"2px",
            content:'"Consumed"'
        },
         
      },
    }));

    function handleChangeEnergyCostBudget(event){
        setStateVarConsumerSaver(!energyconsumersaver);
    };

    return (
      <div style={{borderRadius:"20px"}}>
          <MaterialUISwitch
              checked={energyconsumersaver}
              onChange={handleChangeEnergyCostBudget}
              name="Name"
              inputProps={{ "aria-label": "secondary checkbox" }}
          />                           
      </div>
    );
  }